/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type * as zod from "zod";
import {ExpedientEditableFields} from "./expedientEditableFields.zod";

export const UpdateExpedientRequest = ExpedientEditableFields;

export type UpdateExpedientRequest = zod.input<typeof UpdateExpedientRequest>;
export type UpdateExpedientRequestOutput = zod.output<typeof UpdateExpedientRequest>;
